import { IWorkbookElement } from "utils/constants/interfaces";
import { Button, Container } from "components/shared";
import { Text } from "components/shared/ui-elements";
import { BsFileEarmarkSpreadsheet, BsFiletypePdf } from "react-icons/bs";
import { hooks, mainSelectors } from "state";

interface WorkbookElementsListProps {
  workbookElements: IWorkbookElement[];
  download: (
    workbookElementGuid: any,
    format: any,
    fileName: any,
    elementDisplayName: string | undefined
  ) => void;
}

const WorkBookElementsList = ({ workbookElements, download }: WorkbookElementsListProps) => {
  const { useAppSelector } = hooks;
  const allowedFormats = useAppSelector(mainSelectors.selectWorkbookAllowedFormats);

  const noFormatsAvailable = !allowedFormats.pdf && !allowedFormats.csv && !allowedFormats.xlsx;

  const sortedElements = [...workbookElements].sort(
    (a, b) => a.elementOrder - b.elementOrder
  );

  if (noFormatsAvailable) {
    return (
      <Container className="workbook-element-row">
        <Text>No download formats available for this workbook</Text>
      </Container>
    );
  }

  return (
    <>
      {sortedElements?.length > 1 && (
        <Container className={"workbook-element-row"}>
          <Container className={"workbook-element-title"}>
            <Text>{"Download All"}</Text>
          </Container>
          <Container className={"workbook-element-download-options"}>
            {allowedFormats.pdf && (
              <Button onClick={() => download("all", "pdf", sortedElements, undefined)}>
                <Text>PDF</Text>
                <BsFiletypePdf size={20} />
              </Button>
            )}
            {allowedFormats.csv && (
              <Button onClick={() => download("all", "csv", sortedElements, undefined)}>
                <Text>CSV</Text>
                <BsFileEarmarkSpreadsheet size={20} />
              </Button>
            )}
            {allowedFormats.xlsx && (
              <Button onClick={() => download("all", "xlsx", sortedElements, undefined)}>
                <Text>XLSX</Text>
                <BsFileEarmarkSpreadsheet size={20} />
              </Button>
            )}
          </Container>
        </Container>
      )}

      {sortedElements?.map(({ workbookDisplayName, workbookElementGuid, elementDisplayName }) => (
        <Container className={"workbook-element-row"} key={workbookElementGuid}>
          <Container className={"workbook-element-title"}>
            <Text>{elementDisplayName}</Text>
          </Container>
          <Container className={"workbook-element-download-options"}>
            {allowedFormats.pdf && (
              <Button
                onClick={() =>
                  download(workbookElementGuid, "pdf", workbookDisplayName, elementDisplayName)
                }
              >
                <Text>PDF</Text>
                <BsFiletypePdf size={20} />
              </Button>
            )}
            {allowedFormats.csv && (
              <Button
                onClick={() =>
                  download(workbookElementGuid, "csv", workbookDisplayName, elementDisplayName)
                }
              >
                <Text>CSV</Text>
                <BsFileEarmarkSpreadsheet size={20} />
              </Button>
            )}
            {allowedFormats.xlsx && (
              <Button
                onClick={() =>
                  download(workbookElementGuid, "xlsx", workbookDisplayName, elementDisplayName)
                }
              >
                <Text>XLSX</Text>
                <BsFileEarmarkSpreadsheet size={20} />
              </Button>
            )}
          </Container>
        </Container>
      ))}
    </>
  );
};

export default WorkBookElementsList;
